// extracted by mini-css-extract-plugin
export default {"container":"FiltersRelation_container__3H11M","disabled":"FiltersRelation_disabled__A5qoh","tooltip":"FiltersRelation_tooltip__EBMn0"};